import { useMutation } from "@apollo/client/react";
import {
  CreateKurssloeyfeInFolder,
  CreateKurssloeyfeInFolderVariables,
} from "__generated__/types";
import { CancelOrSubmit } from "common/buttons";
import { MutationLoadingOrError } from "common/components/forms/MutationLoadingOrError";
import { TextField } from "common/components/forms/TextField";
import gql from "graphql-tag";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";

const MUTATION = gql`
  mutation CreateKurssloeyfeInFolder($input: CreateKurssloeyfeInFolderInput!) {
    createKurssloeyfeInFolder(input: $input) {
      folderKurssloeyfe {
        id
      }
    }
  }
`;

interface FormValues {
  title: string;
}

interface Props {
  folderId: string;
  cancel(): void;
  complete(): void;
}

export const CreateKurssloeyfeForm: React.FC<
  React.PropsWithChildren<Props>
> = ({ folderId, cancel, complete }) => {
  const methods = useForm<FormValues>();

  const [mutate, { loading, error }] = useMutation<
    CreateKurssloeyfeInFolder,
    CreateKurssloeyfeInFolderVariables
  >(MUTATION);

  const onSubmit = async (data: FormValues) => {
    const result = await mutate({
      variables: {
        input: {
          folderId,
          title: data.title,
        },
      },
    });

    if (result.data) {
      complete();
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <TextField
          title="Tittel"
          fieldProps={methods.register("title", {
            required: "Du må fylle inn dette feltet",
          })}
        />

        <MutationLoadingOrError loading={loading} error={error} />

        <CancelOrSubmit onCancel={cancel} isLoading={loading} />
      </form>
    </FormProvider>
  );
};
